import { IconEllipsisHLight } from '@swaggerhub-portal/component-library'
import { clsx } from 'clsx'

export const BreadcrumbEllipsis = () => (
  <li
    className={clsx(
      'align-middle flex items-center text-body3 text-neutral-70 dark:text-neutral-40 h-5',
      "after:content-['>'] after:text-neutral-70 dark:after:text-neutral-40 after:mx-1",
    )}
  >
    <IconEllipsisHLight width={12} height={12} />
  </li>
)

export interface BreadcrumbItemProps {
  title: string,
  id: string,
  className?: string,
  renderEllipsis?: boolean,
  isLastItem?: boolean
}

export const BreadcrumbItem = ({ title, id, className, renderEllipsis = false, isLastItem = false }: BreadcrumbItemProps) => (
  <>
    <li
      id={id}
      className={clsx(
        'text-body3 text-neutral-70 dark:text-neutral-40 py-[1px] md:py-0 items-center whitespace-nowrap',
        !renderEllipsis && "last:after:content-none after:content-['>'] after:text-neutral-80 dark:after:text-neutral-30 after:mx-1",
        // If `renderEllipsis` is true (first and last item exceeds container width), apply different styles
        // - For short titles (< 50 characters), use `inline-flex` to render the full title
        // - For long titles, use `block` with ellipsis to truncate the text
        renderEllipsis && (title.length < 50 ? 'inline-flex' : 'block min-w-0 overflow-hidden text-ellipsis'),
        className
      )}
    >
      {title}
    </li>
    {/* When the browser renders ellipsis, it interferes with the ::after pseudo-element content (">").
        Therefore, we render the ">" character as a separate element to ensure it displays correctly. */}
    {renderEllipsis && !isLastItem && <li className="mx-1 text-body3 text-neutral-80 dark:text-neutral-30">&gt;</li>}
  </>
)